import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './external/authentication/login/containers/login/login.component';
import { PageComponent } from './internal/page.component';
import { ConexoesComponent } from './internal/views/conexoes/conexoes.component';
import { MonitoramentoComponent } from './internal/views/monitoramento/monitoramento.component';
import { RouterGuardService } from './service/router-guard/router-guard.service';
import { DetailConnectedItemComponent } from './internal/views/conexoes/containers/detail-connected-item/detail-connected-item.component';


export const routes: Routes = [
    // Rota pública de autenticação
    {
        path: 'autenticacao/login',
        component: LoginComponent
    },
    {
        path: 'selecao-modulo',
        redirectTo: 'conexoes',
        pathMatch: 'full',
    },
    {
        path: '',
        canActivate: [RouterGuardService],
        component: PageComponent,
        children: [
            // Módulo 1: Análise de Dados
            {
                path: 'conexoes',
                canActivate: [RouterGuardService],
                component: ConexoesComponent
            },
            {
                path: 'conexoes/detalhes/:id',
                canActivate: [RouterGuardService],
                component: DetailConnectedItemComponent
            },
            // Módulo 2: Monitoramento
            {
                path: 'monitoramento',
                canActivate: [RouterGuardService],
                component: MonitoramentoComponent
            }
        ]
    },
    {
        path: '**',
        redirectTo: 'conexoes'
    }
];

@NgModule({
    imports: [
      RouterModule.forRoot(routes, { useHash: true, preloadingStrategy: PreloadAllModules })
    ],
    exports: [RouterModule],
    providers: []
})
export class AppRoutingModule { }
